// extracted by mini-css-extract-plugin
module.exports = {"shopPage":"Style_shopPage__gEFeL","regisButton0":"Style_regisButton0__27x_2","regisButton1":"Style_regisButton1__38pr0"};